import {memo, useState} from 'react';
import {cn} from '@/app/utils/CN';
import Link from 'next/link';
import CloseIcon from '@/components/icons/CloseIcon';
import MenuIcon from '@/components/icons/MenuIcon';
import {NavigationItems} from '@/components/navigation/NavigationItems';

const MobileNavigation = memo(() => {
  const [opened, setOpened] = useState(false);

  return (
    <>
      {opened ? (
        <div className={'fixed inset-0 bg-fixed w-screen h-screen bg-black bg-opacity-80 z-40'} />
      ) : null}
      <div
        className={cn('fixed bottom-10 right-10 flex flex-col items-end xl:hidden z-50')}
        onBlur={(e) => {
          if (!e.relatedTarget) {
            setOpened(false);
          }
        }}
      >
        <nav className={cn('flex flex-col gap-5 w-full mb-4', {hidden: !opened})}>
          {NavigationItems.map(({href, name}, idx, items) => (
            <Link
              href={href}
              key={'nav-item-' + idx}
              onClick={() => setOpened(false)}
              className={cn(
                'flex justify-between items-center gap-1 h-[56px] rounded-full px-3 w-full animate-fade-in-right ',
                'bg-primary text-secondary dark:bg-secondary-dark dark:text-primary-dark'
              )}
              style={{animationDuration: `${200 * (items.length - idx)}ms`}}
            >
              <p className={cn('font-bold')}>{name}</p>
            </Link>
          ))}
        </nav>
        <button
          className={cn(
            'flex items-center justify-center z-10 duration-500 rounded-full p-2 size-[56px]',
            'bg-primary dark:bg-secondary-dark border border-secondary dark:border-primary-dark'
          )}
          onClick={() => setOpened((v) => !v)}
        >
          {opened ? (
            <CloseIcon
              className={cn(
                'stroke-secondary dark:stroke-primary-dark',
                'animate-fade-in duration-500'
              )}
            />
          ) : (
            <MenuIcon
              className={cn(
                'stroke-secondary dark:stroke-primary-dark',
                'animate-fade-in duration-500'
              )}
            />
          )}
        </button>
      </div>
    </>
  );
});

export default MobileNavigation;
